import * as React from 'react';
import {useState, useEffect} from 'react';
import InputLabel from '@mui/material/InputLabel';
import  Button  from '@mui/material/Button';
import OrganizationData from '../../../data/OrganizationData';
import SoftBrandingData from '../../../data/SoftBrandingData';
import { useSession } from '../../../context/SessionContext';
import { useLoginServer } from '../../../context/LoginServerContext';
import { useAuthContext } from '../../../context/AuthContext';
 import { modules, features, LicenceTypes } from '../../../data/ControlledLists';
import CustomFieldsMetadata from '../../../data/CustomFieldsMetadata'; 
import ModulesFeaturesInformation from './ModulesFeaturesInformation';
import { CSVString2Array, Array2CSVString } from '../../../Utilities/Utilities';
import { KamsModuleList, KamsExpressModuleList, KamsGolfModuleList, KamsGolfExpressModuleList, KamsIlModuleList, KamsJoint3DModuleList, ROFWorkflowModuleList } from '../../../data/ControlledLists';

import { mainFeatures, correctivesFeatures, WorkflowAssessmentList} from '../../../data/ControlledLists';

 const  ModulesFeaturesEdit = ({data, onFieldChange, onSave}) => {   
    console.log("Modules Features Data: ",data);
    
    const [organization, setOrganization] = useState(data);
    const [errorMessage, setErrorMessage] = useState(false);
    const [savedMessage, setSavedMessage] = useState(false);
    const [warningFlag, setWarningFlag] = useState(false);
    const [message, setMessage] = useState("");
    
    const session = useSession();
    const loginServerURL = useLoginServer();
    const {currentToken} = useAuthContext();
    const [allFeatures, setAllFeatures] = useState([]);
    const [branding, setBranding] = useState([]);
    const [CFFeatures, setCFFeatures] = useState([]);
    const [flexLicenceTemplates, setFlexLicenceTemplates] = useState([]);
    const [presetWorkflows, setPresetWorkflows] = useState([]);
    const [data1, setData1] = useState({"type":"", "name":"", "modules":"", "features":""});
    const [displayList, setDisplayList] = useState(false);
    const [list, setList] = useState([]);
    const [title, setTitle] = useState("");
    const [search, setSearch] = useState(false);
    const [searchString, setSearchString] = useState("");
    const [skip, setSkip] = useState(0);
    const [value, setValue] = useState(0);
    const [loading, setLoading] = useState(true);
  
    //chevy addon
        //const [flexLicenceTemplates, setFlexLicenceTemplates] = useState([]);
        //const [presetWorkflows, setPresetWorkflows] = useState([]);
        const [featuresList, setFeaturesList] = useState([]);
        const [brandingList, setBrandingList] = useState([]);
        const [correctivesList, setCorrectivesList] = useState([]);
        const [presetWorkflowList, setPresetWorkflowList] = useState([]);
        const [cfTemplatesList, setCFTemplatesList] = useState([]);

    console.log("ModuleFeatures: ",organization);

    

    useEffect (() => {
        getBrandingFeatures();
        getCustomFieldMetadata();
        getFlexLicenceTemplates();
        getPresetWorkflow();
    },[]);
    
    useEffect(() => {
        setOrganization(data);
    }, [data]);

    const getCustomFieldMetadata = () => {
        var rows = [CustomFieldsMetadata];
        let queryString = `?$filter=((id ne null) and (updatedAt ge 1970-01-01T20:00:00Z))&$orderby=updatedAt&$skip=0&top=1000`
        fetch(loginServerURL + "/tables/CustomFieldsMetaData" + queryString, {
            method: 'GET',
            headers:{
                "X-ZUMO-AUTH": currentToken,
                "Content-type":"application/json"
            }
        }).then ((response) => response.json())
        .then ((data) => {
            rows = data.filter((r) => r.isDeleted === false);
            var list = [];
            rows.forEach((p) => {
                list.push(p.featureName);
            });
            setCFFeatures(list);
        }).catch ((error) => {
            console.log("MD Error: ",error);
        });  
    }

    function getFlexLicenceTemplates () {
        let queryString = `?$filter=((id ne null) and (updatedAt ge 1970-01-01T20:00:00Z))&$orderby=updatedAt&$skip=0&top=1000`
        console.log("queryData: ",queryString)
      try { 
        fetch(session.subscriptionServer + "/tables/FlexLicenceTemplate/" + queryString, {
            method: 'GET',
            headers:{"Content-type":"application/json"}
        }).then ((response) => response.json())
        .then ((data) => {
          setFlexLicenceTemplates(data);
          
        }).catch ((error) => {
            console.log(error);
        });  
      } catch(err) {
        console.log(err);
      }
    }

    function getBrandingFeatures () {
        fetch(session.subscriptionServer + "/api/GetBrandingList" , {
            method: 'GET',
            headers:{
                "X-ZUMO-AUTH": currentToken,
                "Content-type":"application/json"
            }
        }).then ((response) => response.json())
        .then ((data) => {
            setBranding(data); 
        }).catch ((error) => {
            console.log("BrandingError Error: ",error);
            return [];
        });  
    }
    function getPresetWorkflow () {
        let queryString = `?$filter=((id ne null) and (updatedAt ge 1970-01-01T20:00:00Z))&$orderby=updatedAt&$skip=0&top=1000`
        fetch(loginServerURL + "/tables/PresetWorkflow" + queryString, {
            method: 'GET',
            headers:{
                "X-ZUMO-AUTH": currentToken,
                "Content-type":"application/json"
            }
        }).then ((response) => response.json())
        .then ((data) => {
            setPresetWorkflows(filterPresetWorkflowList(data)); 
        }).catch ((error) => {
            console.log("PresetWorkflow Error: ",error);
            return [];
        });  
    }

    const filterPresetWorkflowList = (data) => {
        let list = data.filter((r) => r.isDeleted === false && r.kinetisensePresetWorkflow === true);
        return list.map((a) => ({name: a.name, assessmentTypesString: a.assessmentTypesString, associatedCFTemplate: a.associatedCFTemplate}));
    }

    const handleFieldUpdate = (event, value, id) => {
        //console.log("handleFieldUpdate called with:", id);
        
        //console.log("EnableSavePasswordPolicy: ", value, id)
        var sb = SoftBrandingData;
        const updatedDate = Date.UTC;
        if (organization.softBrandingBlob !== null && organization.softBrandingBlob !== "") {
            sb = JSON.parse(organization.softBrandingBlob);
        }
        var x = null;

        // chevy addon
        if (id ==='modules') {
                x = {...organization, modules: Array2CSVString(value), updatedAt: updatedDate  };
                setOrganization(x);
                onFieldChange(x);
                
        } else if (id ==='features') {
                setFeaturesList(value);
            // rebuild the fearures list
            setOrganization({...organization, features: Array2CSVString(value.concat(brandingList).concat(correctivesList).concat(cfTemplatesList).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
        } else if (id ==='cfTemplates') {
            setCFTemplatesList(value);
            setOrganization({...organization, features: Array2CSVString(featuresList.concat(brandingList).concat(correctivesList).concat(value).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
        } else if (id ==='branding') {
            console.log("made it to branding");
            setBrandingList(value);
            setOrganization({...organization, features: Array2CSVString(featuresList.concat(value).concat(correctivesList).concat(cfTemplatesList).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
        } else if (id ==='correctives') {
            setCorrectivesList(value);
            setOrganization({...organization, features: Array2CSVString(featuresList.concat(brandingList).concat(value).concat(cfTemplatesList).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
        } else if (id ==='presetWorkflows') {
            var list = organization.modules;
            setPresetWorkflowList(value);
            var newFeatures = value;
            var newcfTemplatesList = cfTemplatesList;
            


            value.forEach((f) => {
                //console.log("Feature: ",f);
                

                // new way to add the modules
                var workflow = presetWorkflows.filter((r) => r.name === f);
                // console.log("Workflow: ",workflow);
                //console.log("Workflow: ",workflow.associatedCFTemplate);
                //console.log("CFFeattures", CFFeatures);
                if (workflow.length > 0) {
                    
                    var types = workflow[0].assessmentTypesString.split(",");
                    // console.log("Types: ",types);
                    types.forEach((m) => {
                        if (list !== "") {
                            list = list.concat(",");
                        }
                        // console.log("M: ",m);
                        // console.log("WorkflowAssessmentList: ",WorkflowAssessmentList);
                        list = list.concat(WorkflowAssessmentList.filter((r) => r.name === m).map(a => a.module));
                        // console.log("List: ",list);
                    }) 
                    if (
                        workflow[0].associatedCFTemplate !== null &&
                        workflow[0].associatedCFTemplate !== "" &&
                        !newcfTemplatesList.includes(workflow[0].associatedCFTemplate)
                    ) {
                        newcfTemplatesList.push(workflow[0].associatedCFTemplate);
                        setCFTemplatesList(newcfTemplatesList);
                    }                
                }
            });

            //var newModules = Array2CSVString([...new Set((CSVString2Array(list)))]);
            //setRow({...row, features: Array2CSVString(featuresList.concat(brandingList).concat(correctivesList).concat(newcfTemplatesList).concat(newFeatures)), modules:newModules, updatedAt: updatedDate });
            //var newModules = Array2CSVString([...new Set((CSVString2Array(list)))]);

            var newModules = Array2CSVString([...new Set((CSVString2Array(list)))]);
            x = {...organization, features: Array2CSVString(featuresList.concat(brandingList).concat(correctivesList).concat(newcfTemplatesList).concat(newFeatures)), modules:newModules, updatedAt: updatedDate };
            setOrganization(x);
            onFieldChange(x);

        } else if ("flexLicenceTemplateName") {
                flexLicenceTemplates.forEach((el) =>{
                    console.log(el.name)
                    if (el.name === value) {
                        x = {...organization, flexLicenceTemplateName: value, modules: el.modules, features: el.features, updatedAt: updatedDate };
                        setOrganization(x);
                        onFieldChange(x);
                    }
                    
                });
                      
          
        } else {
            console.log("Missing: ",id)
        }
      }

    const handleSave = (event) => {
        event.preventDefault();
        console.log("Save: ",organization);
        try{
            onSave();
            setSavedMessage(true);
            setErrorMessage(false);
            setTimeout(() => {
                setSavedMessage(false);
            }, 5000);
        } catch (error) {
            console.log("Error: ",error);
            setErrorMessage(true);
            setSavedMessage(false);
            setTimeout(() => {
                setErrorMessage(false);
            }, 5000);
        }
    }

    const featureList = () => {
        // console.log("Features: ",features);
        // console.log("Branding: ",branding);
        // console.log("CFFeatures: ",CFFeatures);
        // console.log("PresetWorkflows: ",presetWorkflows);
        let result = new Set((CFFeatures.concat(features).concat(branding).concat(presetWorkflows)));
        result = [...result].sort((a, b) => (a > b ? 1 : -1));
       //console.log("FeatureList: ",result);
        return result;
    }

    const filterFeatureList = (features, list) => {
        // console.log("Features: ",features);
        // console.log("List: ",list);
        let filteredList = [];
        features.forEach((f) => {
            list.forEach((l) => {
                if (f === l) {
                    filteredList.push(l);
                }
            })
        })
        // console.log("Filtered List: "+list, filteredList);
        return filteredList.sort((a, b) => (a > b ? 1 : -1));
    }
    //console.log("presetWorkflows: ",presetWorkflows);
    if (organization !== undefined) {
    return (
        <div>
        <form onSubmit={handleSave}>
            <div className="formInput"  Style={{margin:"10px", width:"700"}}>
               
                <box Style={{width:500}}>
                    <ModulesFeaturesInformation
                        data = {organization}
                        modules={modules}
                        
                        
                        flexLicenceTemplates={flexLicenceTemplates}
                        licenceTypes={LicenceTypes}

                        //chevy addon
                        mainFeatures={mainFeatures}
                        CFFeatures={CFFeatures}
                        branding={branding}
                        presetWorkflows={presetWorkflows}
                        correctivesFeatures={correctivesFeatures}
                        selectedMainFeatures={filterFeatureList(CSVString2Array(organization.features), mainFeatures)}
                        selectedCFFeatures={filterFeatureList(CSVString2Array(organization.features), CFFeatures)}
                        selectedBranding={filterFeatureList(CSVString2Array(organization.features), branding)}
                        selectedPresetWorkflows={filterFeatureList(CSVString2Array(organization.features), presetWorkflows.map((a) => a.name))}
                        selectedCorrectivesFeatures={filterFeatureList(CSVString2Array(organization.features), correctivesFeatures)}
                        onFieldChange={(event,value, id) => handleFieldUpdate(event, value, id)}
                    />
                    
                </box>
            <div className="formButtons" style={{width:800}} >
                    <div className="left">
                        {errorMessage && <div className="error">An error occurred</div>}
                        {savedMessage && <div className="message">Modules and Features Saved</div>}
                        {warningFlag && <div className="warning">{message}</div>}
                    </div>
                    <div className="right">
                        <Button  
                            type="submit"
                            variant="contained"
                            className="button"
                            >
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </form>
        </div>
    );
    } else {
        return (<label>Loading...</label>)
    }
}

export default ModulesFeaturesEdit;